import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, Lightbulb, Repeat } from 'lucide-react';
import { InteriorSlide, SlideHeader, SlideBanner } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide02ExecSummary({
  index
}: SlideProps) {
  const cards = [{
    icon: AlertCircle,
    title: 'The challenge',
    text: 'HCP attention is harder to win with static digital formats.',
    delay: 0.4
  }, {
    icon: Lightbulb,
    title: 'The opportunity',
    text: 'The established brands already have strong content and prescriber familiarity.',
    delay: 0.55
  }, {
    icon: Repeat,
    title: 'The solution',
    text: 'Reusable master assets with monthly interactive campaign adaptations.',
    delay: 0.7
  }];
  return <InteriorSlide surface banner={<SlideBanner eyebrow="The Goal" data-id="element-69" data-mp="21qvvdjbsr24w">
          Turn monthly campaigns across the established brand portfolio into short,
          interactive experiences that capture attention, increase engagement,
          and generate behavioral insights.
        </SlideBanner>} data-id="element-68" data-mp="1wsugzbpbfqzr">
      <SlideHeader eyebrow="Executive Summary" data-id="element-70" data-mp="2r7wi4nt7ou6i">
        Short. Sharp.{' '}
        <span className="text-[var(--brand)]" data-id="element-71" data-mp="2m78r424zgdca">Satisfying.</span>
      </SlideHeader>

      <div className="flex-1 flex flex-col justify-center max-w-6xl mx-auto w-full" data-id="element-72" data-mp="2i66p5djoln6m">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3,
        duration: 0.6
      }} className="mb-12 max-w-4xl" data-id="element-73" data-mp="3evnrpjndat43">
          <p className="text-[clamp(1.4rem,2.1vw,2rem)] font-bold text-[var(--fg)] leading-snug mb-4" data-id="element-74" data-mp="312y6vijkru8k">
            HCPs don't need more content. They need more value from the time
            they give us.
          </p>
          <p className="text-[clamp(1.05rem,1.4vw,1.3rem)] text-[var(--muted)] leading-relaxed" data-id="element-75" data-mp="3stm6ur9iitkn">
            GSK's established brands are promoted 100% digitally, and the
            communication is strong — but engagement is fading across the
            portfolio. Snakker turns every campaign into a short interactive
            experience worth the 30 seconds it asks for, built once and adapted
            brand by brand.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8" data-id="element-76" data-mp="186vvdi2e01be">
          {cards.map((card, i) => {
          const Icon = card.icon;
          return <motion.div key={card.title} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: card.delay,
            duration: 0.6
          }} className="bg-white rounded-2xl p-8 shadow-sm border border-black/5 relative overflow-hidden group" data-id="element-77" data-mp="y8zavznk7u0m" data-mpi={i}>
                <div className="absolute top-0 right-0 w-32 h-32 bg-[var(--brand)]/5 rounded-bl-full -mr-16 -mt-16 transition-transform group-hover:scale-110" data-id="element-78" data-mp="gzx2s600faoq" />
                <div className="h-12 w-12 rounded-xl bg-[var(--surface)] flex items-center justify-center mb-6 text-[var(--brand)]" data-id="element-79" data-mp="vpujy1ziv04f">
                  <Icon className="h-6 w-6" data-id="element-80" data-mp="14oy1v2myd9hc" />
                </div>
                <h3 className="text-xl font-bold text-[var(--fg)] mb-3" data-id="element-81" data-mp="14rauc9qc728n">
                  {card.title}
                </h3>
                <p className="text-[var(--muted)] leading-relaxed" data-id="element-82" data-mp="1endsl4i2igqb">
                  {card.text}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </InteriorSlide>;
}